import React, { useEffect, useState } from "react";

import { Button } from "react-bulma-components";
import DatePicker from "react-date-picker";
import styled from "styled-components";

import { RESPONSIVE } from "helpers/responsive";
import { PreparedRoute } from "models/preparedRoute";

const ExpirationDateDialogModalCard = styled.div`
  height: calc(100vh - 40px);

  @media ${RESPONSIVE.DESKTOP} {
    width: 1024px;
  }
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
`;

export interface ExpirationDateDialogProps {
  isVisible: boolean;
  preparedRoute?: PreparedRoute;
  toggleDialog: () => void;
  registerExpirationDate: (preparedRoute: PreparedRoute) => void;
}

export function ExpirationDateDialog({
  isVisible,
  preparedRoute,
  toggleDialog,
  registerExpirationDate,
}: ExpirationDateDialogProps): React.ReactElement | null {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [errorMessage, setErrorMessage] = useState("");

  const requiredStartDateMessage = "開始日は必ず入力してください。";
  const rangeEndDateMessage = "終了日は9999/12/31以前にしてください。";
  const cantBeLaterMessage = "開始日が終了日よりも未来です。";

  useEffect(() => {
    if (preparedRoute) {
      setStartDate(preparedRoute.startDate);
      setEndDate(preparedRoute.endDate);
    }
  }, [preparedRoute]);

  const initState = () => {
    setStartDate(new Date());
    setEndDate(new Date());
    setErrorMessage("");
  };
  const handleToggleDialog = () => {
    initState();
    toggleDialog();
  };
  const handleChangeStartDate = (event: Date | Date[]) => {
    if (event instanceof Date) {
      setStartDate(event);
      setErrorMessage("");
    } else if (event === null) {
      setStartDate(event);
      setErrorMessage(requiredStartDateMessage);
    }
  };
  const handleChangeEndDate = (event: Date | Date[]) => {
    if (event instanceof Date) {
      setEndDate(event);
      if (event.getFullYear() > 9999) {
        setErrorMessage(rangeEndDateMessage);
      } else {
        setErrorMessage("");
      }
    } else if (event === null) {
      setEndDate(event);
      setErrorMessage("");
    }
  };
  const handleSet = () => {
    if (startDate === null) {
      setErrorMessage(requiredStartDateMessage);
    } else if (endDate != null && endDate.getFullYear() > 9999) {
      setErrorMessage(rangeEndDateMessage);
    } else if (startDate > endDate) {
      setErrorMessage(cantBeLaterMessage);
    } else {
      if (preparedRoute) {
        // eslint-disable-next-line no-param-reassign
        preparedRoute.startDate = startDate;
        if (endDate) {
          // eslint-disable-next-line no-param-reassign
          preparedRoute.endDate = endDate;
        } else {
          // eslint-disable-next-line no-param-reassign
          preparedRoute.endDate = new Date(9999, 11, 31);
        }
        registerExpirationDate(preparedRoute);
      }
      initState();
      toggleDialog();
    }
  };

  if (!preparedRoute) {
    return null;
  }
  return (
    <div
      className={`modal cw-expiration-date-dialog ${
        isVisible ? "is-active" : ""
      }`}
    >
      <div className="modal-background" />
      <ExpirationDateDialogModalCard className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">有効期限設定</p>
          <button
            type="button"
            className="delete"
            aria-label="close"
            onClick={(_event) => handleToggleDialog()}
          />
        </header>
        <section className="modal-card-body ">
          開始日：
          <DatePicker
            locale="ja-JP"
            required
            showLeadingZeros
            maxDate={new Date("9999/12/31")}
            name="startDate"
            onChange={(event: Date) => handleChangeStartDate(event)}
            value={startDate}
          />
          &nbsp;〜&nbsp;終了日：
          <DatePicker
            locale="ja-JP"
            required={false}
            showLeadingZeros
            maxDate={new Date("9999/12/31")}
            name="endDate"
            onChange={(event: Date) => handleChangeEndDate(event)}
            value={endDate}
          />
          <p className="help is-danger">{errorMessage}</p>
        </section>
        <ModalFooter className="modal-card-foot">
          <Button onClick={() => handleToggleDialog()}>キャンセル</Button>
          <Button color="primary" onClick={() => handleSet()}>
            設定
          </Button>
        </ModalFooter>
      </ExpirationDateDialogModalCard>
    </div>
  );
}
